import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { Link, NavLink, useLocation } from "react-router-dom";
import SubMenus from "./SubMenu";
import { useMediaQuery } from "react-responsive";
import "../../constants/css/custom_styles.css";
import { HiHome, HiOutlineVideoCamera, HiUserAdd } from "react-icons/hi";
import { getMachines, getMachineToggles, getMasterjiOldLocks, postMasterjiOldLocks, toggleMachineToggles } from "../../services/clinic/machines";
import { GiMedicinePills, GiMedicines } from "react-icons/gi";
import { getUserRole } from "../../utils/localStoarege";
import { MdAssistant, MdDewPoint, MdOutlineMedicalServices, MdRealEstateAgent } from "react-icons/md";
import { FiPackage } from "react-icons/fi";
import { AiOutlineAppstore } from "react-icons/ai";
import { ToggleSwitch } from "../ToggleSwitch/ToggleSwitch";
import { BiSolidLock } from "react-icons/bi";
import { FaHands } from "react-icons/fa";
import { CiSettings } from "react-icons/ci";
import { BsGearFill } from "react-icons/bs";
import { toast } from "react-toastify";
import ShowModal from "../Hud/ShowModal";
import VerifyOtpPop from "./VerifyOtpPopView";
import { RiUser2Fill } from "react-icons/ri";
import Button from "../buttons/Button";

const ClinicSidebar = () => {
  const location = useLocation();
  const [machineSwitches, setMachineSwitches] = useState([]);
  let isTab = useMediaQuery({ query: "(max-width: 768px)" });
  const [isOpen, setIsOpen] = useState(isTab ? false : true);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [machines, setMachines] = useState([]);
  const [oldLocks, setOldLocks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingToggles, setLoadingToggles] = useState(false);
  const [loadingOldLocks, setLoadingOldLocks] = useState(false);
  const timerRef = useRef(null);

  const [modalIsOpen, setIsModelOpen] = useState(false);
  const [openingItem, setOpeningItem] = useState({});


  // Open modal with the selected PDF ID
  const openModal = (item) => {
    setOpeningItem(item);
    setIsModelOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setIsModelOpen(false);
    setOpeningItem({});
  };

  useEffect(() => {
    const fetchMachines = async () => {
      setLoading(true);
      try {
        let res = await getMachines();
        setMachines(res.data.results);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching Machines:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchMachines();
    fetchMachineToggles();


    // Set up the interval to fetchMachineToggles every 30 seconds
    timerRef.current = setInterval(() => {
      fetchMachineToggles(false);
    }, 30000);

    // Cleanup the interval when the component unmounts
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  const fetchMachineToggles = async (needLoading = true) => {
    try {
      if (needLoading) {
        setLoadingToggles(true);
      }
      let res = await getMachineToggles();
      if (res.status === 200) {
        setMachineSwitches(res.data);
      } else {
        toast.error("Unable to get switches");
      }
      setLoadingToggles(false);
    } catch (error) {
      console.error("Error fetching Machines:", error);
    }
  };

  const fetchMasterjiOldLocks = async () => {
    try {
      setLoadingOldLocks(true);
      let res = await getMasterjiOldLocks();
      if (res.status === 200) {
        setOldLocks(res.data);
      } else {
        toast.error("Unable to get old locks");
      }
      setLoadingOldLocks(false);
    } catch (error) {
      console.error("Error fetching old locks:", error);
    }
  };

  const handleOperateOperation = async ({ data }) => {
    try {
      let res = await postMasterjiOldLocks({
        data: {
          type: data.type,
        }
      });
      if (res.status === 200) {
        toast.success(res.data.message);
      } else {
        toast.error("Unable to operate machine");
      }
      setLoadingOldLocks(false);
    } catch (error) {
      console.error("Error operating machine:", error);
    }
  };

  const [isActive, setIsActive] = useState({
    dashboard: false,
    tpt_machines: false,
    invoice: false,
    patients: false,
    consultation: false,
    medicine: false,
    hud_patients: false,
    hud_add: false,
    doctor_view: false,
    issued_medicines: false,
    medicine_invoice: false,
    video_call: false,
    enquiry: false,
  });

  useEffect(() => {
    setIsOpen(!isTab);
  }, [isTab]);

  useEffect(() => {
    const path = location.pathname;

    setIsActive({
      dashboard: path === "/dashboard",
      tpt_machines: path === "/tpt-machines",
      package_invoice: path.includes("/package-invoice"),
      patients: path === "/patients",
      consultation: path.includes("/consultation-invoice"),
      medicine: path.includes("/medicine") || path.includes("/center-medicine"),
      hud_patients: path.includes("/new-hud-patients") && path !== "/new-hud-patients/add",
      hud_add: path === "/new-hud-patients/add",
      doctor_view: path.includes("/clinic/doctor-view"),
      issued_medicines: path.includes("/issued-medicines"),
      medicine_invoice: path.includes("/invoice-medicine"),
      video_call: path.includes("/video-call"),
      enquiry: path === "/enquiry" || path === "/enquiry/add",
    });
    fetchMasterjiOldLocks();
  }, [location.pathname]);

  const handleIsActive = (key) => {
    setIsActive((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  const handleSwitchToggle = async (item, bypass = false) => {
    if (!item.is_old || bypass) {
      try {
        setLoadingToggles(true);
        let res = await toggleMachineToggles(item.id, { is_door: item.is_door === "open" ? "closed" : "open" });
        if (res.status === 200) {
          if (bypass) {
            closeModal();
          }
          toast.success(`${item.machine} Door Operated`);
          fetchMachineToggles();
        } else {
          toast.error("Error Switching Machines");
        }
        setLoadingToggles(false);
      } catch (error) {
        console.error("Error Switching Machines:", error);
      }
    } else {
      openModal(item);
    }
  };


  const getTypeIcon = (type, is_power) => {
    switch (type) {
      case 'door-lock':
        return <BiSolidLock color={is_power ? "green" : "red"} size={20} />; // Dark Magenta
      case 'hand-feet':
        return <FaHands color={is_power ? "green" : "red"} size={20} />; // Blue
      case 'TPT':
        return <CiSettings color={is_power ? "green" : "red"} size={20} />; // Dark Violet
      case 'Clinic':
        return <MdOutlineMedicalServices color={is_power ? "green" : "red"} size={20} />; // Tomato Red
      default:
        return <BsGearFill color={is_power ? "green" : "red"} size={20} />; // Deep Purple
    }
  };

  return (
    <motion.div
      initial={{ x: -250 }}
      animate={{ x: isOpen ? 0 : -250 }}
      className="bg-secondary text-[#ffffff] shadow-xl w-[16rem] max-w-[16rem] h-full md:overflow-y-scroll 2xl:overflow-hidden md:relative  fixed pl-2"
    >
      <div className="flex flex-col justify-between h-full">
        <div
          className={`text-md whitespace-pre pb-2 pt-4 flex flex-row gap-2 font-bold ${isOpen ? "block" : "hidden"}`}
        >
          <HiHome size={18} />
          Clinic
        </div>
        <hr className="border-white my-2" />
        <div className="overflow-y-auto flex-1">
          {/* Menus */}
          <div className="flex flex-col h-full">
            {/* First */}
            <ul className="whitespace-pre px-2.5 text-[0.9rem] py-3 flex flex-col gap-2 font-medium scrollbar-thin h-full md:h-full">
              {/* Submenus */}
              {(isOpen || isTab) && (
                <div>
                  {
                    loadingToggles ? <></> :
                      <div className="flex flex-col gap-4 mb-2">
                        {machineSwitches.map((machines, index) => (
                          <div key={machines.id} className="flex flex-row gap-2 items-center">
                            {/* Machine Label */}
                            <div
                              className={`flex-1 font-bold ${machines.is_power ? "text-green-500" : machines.machine.includes("HFT") || machines.machine.includes("TPT") ? "text-slate-400" : "text-red-600"
                                }`}
                            >
                              {machines.machine}
                            </div>
                            {/* Toggle Switch */}
                            {
                              machines.machine.includes("HFT") || machines.machine.includes("TPT") ?
                                <ToggleSwitch
                                  label={`${machines.machine}_${index}`}
                                  toggled={machines.is_door === "open"}
                                  onToggle={() => handleSwitchToggle(machines)}
                                /> :
                                <ToggleSwitch
                                  label={`${machines.machine}_${index}`}
                                  toggled={machines.is_door === "open"}
                                  disabled={!machines.is_power}
                                  onToggle={() => handleSwitchToggle(machines)}
                                />
                            }
                          </div>
                        ))}
                      </div>
                  }
                  {machineSwitches.length > 0 && <hr />}
                  {
                    loadingOldLocks ? <></> :
                      <div className="flex flex-col gap-4 my-2">
                        {oldLocks.map((machines, index) => (
                          <div key={index} className="flex flex-row gap-2 items-center">
                            <div
                              className={`flex-1 font-bold uppercase`}
                            >
                              {machines.type}
                            </div>
                            <Button onClick={() => handleOperateOperation({ data: machines })} children={"Operate"} className="bg-primary text-xs py-2 px-4" />
                          </div>
                        ))}
                      </div>
                  }
                  {oldLocks.length > 0 && <hr className="mb-2" />}
                  {[
                    {
                      name: "Machines",
                      baseRoute: "/machines",
                      icon: (
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M15.5999 8.40039H8.3999V15.6004H15.5999V8.40039Z" fill="#ffffff" />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M8.4002 2.4002C8.4002 2.08194 8.52662 1.77671 8.75167 1.55167C8.97671 1.32662 9.28193 1.2002 9.60019 1.2002C9.91845 1.2002 10.2237 1.32662 10.4487 1.55167C10.6738 1.77671 10.8002 2.08194 10.8002 2.4002V3.6002H13.2002V2.4002C13.2002 2.08194 13.3266 1.77671 13.5517 1.55167C13.7767 1.32662 14.0819 1.2002 14.4002 1.2002C14.7185 1.2002 15.0237 1.32662 15.2487 1.55167C15.4738 1.77671 15.6002 2.08194 15.6002 2.4002V3.6002H18.0002C18.6367 3.6002 19.2472 3.85305 19.6973 4.30314C20.1473 4.75323 20.4002 5.36368 20.4002 6.0002V8.4002H21.6002C21.9185 8.4002 22.2237 8.52662 22.4487 8.75167C22.6738 8.97671 22.8002 9.28193 22.8002 9.60019C22.8002 9.91845 22.6738 10.2237 22.4487 10.4487C22.2237 10.6738 21.9185 10.8002 21.6002 10.8002H20.4002V13.2002H21.6002C21.9185 13.2002 22.2237 13.3266 22.4487 13.5517C22.6738 13.7767 22.8002 14.0819 22.8002 14.4002C22.8002 14.7185 22.6738 15.0237 22.4487 15.2487C22.2237 15.4738 21.9185 15.6002 21.6002 15.6002H20.4002V18.0002C20.4002 18.6367 20.1473 19.2472 19.6973 19.6973C19.2472 20.1473 18.6367 20.4002 18.0002 20.4002H15.6002V21.6002C15.6002 21.9185 15.4738 22.2237 15.2487 22.4487C15.0237 22.6738 14.7185 22.8002 14.4002 22.8002C14.0819 22.8002 13.7767 22.6738 13.5517 22.4487C13.3266 22.2237 13.2002 21.9185 13.2002 21.6002V20.4002H10.8002V21.6002C10.8002 21.9185 10.6738 22.2237 10.4487 22.4487C10.2237 22.6738 9.91845 22.8002 9.60019 22.8002C9.28193 22.8002 8.97671 22.6738 8.75167 22.4487C8.52662 22.2237 8.4002 21.9185 8.4002 21.6002V20.4002H6.0002C5.36368 20.4002 4.75323 20.1473 4.30314 19.6973C3.85305 19.2472 3.6002 18.6367 3.6002 18.0002V15.6002H2.4002C2.08194 15.6002 1.77671 15.4738 1.55167 15.2487C1.32662 15.0237 1.2002 14.7185 1.2002 14.4002C1.2002 14.0819 1.32662 13.7767 1.55167 13.5517C1.77671 13.3266 2.08194 13.2002 2.4002 13.2002H3.6002V10.8002H2.4002C2.08194 10.8002 1.77671 10.6738 1.55167 10.4487C1.32662 10.2237 1.2002 9.91845 1.2002 9.60019C1.2002 9.28193 1.32662 8.97671 1.55167 8.75167C1.77671 8.52662 2.08194 8.40019 2.4002 8.4002H3.6002V6.0002C3.6002 5.36368 3.85305 4.75323 4.30314 4.30314C4.75323 3.85305 5.36368 3.6002 6.0002 3.6002H8.4002V2.4002ZM6.0002 6.0002H18.0002V18.0002H6.0002V6.0002Z"
                            fill="#ffffff"
                          />
                        </svg>
                      ),
                      menus: loading ? [] : machines.map((machine) => ({
                        name: machine.machine_name,
                        route: machine.is_old ? `/old-machine/${machine.machine_name}` : `/machine/${machine.machine_name}`,
                        icon: (
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.5999 8.40039H8.3999V15.6004H15.5999V8.40039Z" fill="#ffffff" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.4002 2.4002C8.4002 2.08194 8.52662 1.77671 8.75167 1.55167C8.97671 1.32662 9.28193 1.2002 9.60019 1.2002C9.91845 1.2002 10.2237 1.32662 10.4487 1.55167C10.6738 1.77671 10.8002 2.08194 10.8002 2.4002V3.6002H13.2002V2.4002C13.2002 2.08194 13.3266 1.77671 13.5517 1.55167C13.7767 1.32662 14.0819 1.2002 14.4002 1.2002C14.7185 1.2002 15.0237 1.32662 15.2487 1.55167C15.4738 1.77671 15.6002 2.08194 15.6002 2.4002V3.6002H18.0002C18.6367 3.6002 19.2472 3.85305 19.6973 4.30314C20.1473 4.75323 20.4002 5.36368 20.4002 6.0002V8.4002H21.6002C21.9185 8.4002 22.2237 8.52662 22.4487 8.75167C22.6738 8.97671 22.8002 9.28193 22.8002 9.60019C22.8002 9.91845 22.6738 10.2237 22.4487 10.4487C22.2237 10.6738 21.9185 10.8002 21.6002 10.8002H20.4002V13.2002H21.6002C21.9185 13.2002 22.2237 13.3266 22.4487 13.5517C22.6738 13.7767 22.8002 14.0819 22.8002 14.4002C22.8002 14.7185 22.6738 15.0237 22.4487 15.2487C22.2237 15.4738 21.9185 15.6002 21.6002 15.6002H20.4002V18.0002C20.4002 18.6367 20.1473 19.2472 19.6973 19.6973C19.2472 20.1473 18.6367 20.4002 18.0002 20.4002H15.6002V21.6002C15.6002 21.9185 15.4738 22.2237 15.2487 22.4487C15.0237 22.6738 14.7185 22.8002 14.4002 22.8002C14.0819 22.8002 13.7767 22.6738 13.5517 22.4487C13.3266 22.2237 13.2002 21.9185 13.2002 21.6002V20.4002H10.8002V21.6002C10.8002 21.9185 10.6738 22.2237 10.4487 22.4487C10.2237 22.6738 9.91845 22.8002 9.60019 22.8002C9.28193 22.8002 8.97671 22.6738 8.75167 22.4487C8.52662 22.2237 8.4002 21.9185 8.4002 21.6002V20.4002H6.0002C5.36368 20.4002 4.75323 20.1473 4.30314 19.6973C3.85305 19.2472 3.6002 18.6367 3.6002 18.0002V15.6002H2.4002C2.08194 15.6002 1.77671 15.4738 1.55167 15.2487C1.32662 15.0237 1.2002 14.7185 1.2002 14.4002C1.2002 14.0819 1.32662 13.7767 1.55167 13.5517C1.77671 13.3266 2.08194 13.2002 2.4002 13.2002H3.6002V10.8002H2.4002C2.08194 10.8002 1.77671 10.6738 1.55167 10.4487C1.32662 10.2237 1.2002 9.91845 1.2002 9.60019C1.2002 9.28193 1.32662 8.97671 1.55167 8.75167C1.77671 8.52662 2.08194 8.40019 2.4002 8.4002H3.6002V6.0002C3.6002 5.36368 3.85305 4.75323 4.30314 4.30314C4.75323 3.85305 5.36368 3.6002 6.0002 3.6002H8.4002V2.4002ZM6.0002 6.0002H18.0002V18.0002H6.0002V6.0002Z" fill="#ffffff" />
                          </svg>
                        ),
                        rowData: { ...machine },
                      })),
                    },
                  ].map((item, index) => (
                    <div key={index} className="flex flex-col pl-1 pb-1">
                      <SubMenus
                        data={item}
                        // isOpen={activeSubMenu === index}
                        isOpen={true}
                        toggleSubMenu={() =>
                          setActiveSubMenu(activeSubMenu === index ? null : index)
                        }
                      />
                    </div>
                  ))}
                </div>
              )}
              {<li>
                <NavLink
                  to="/enquiry"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.enquiry ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("enquiry")}
                >
                  <MdAssistant size={18} />
                  <p className={`whitespace-pre ${isOpen ? "block" : "hidden"}`}>
                    Enquiry
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/video-call"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.video_call ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("video_call")}
                >
                  <HiOutlineVideoCamera size={18} />
                  <p className={`whitespace-pre ${isOpen ? "block" : "hidden"}`}>
                    Video Call
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/new-hud-patients/add"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.hud_add ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("hud_add")}
                >
                  <HiUserAdd size={18} />
                  <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                    Add Patient
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/new-hud-patients"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.hud_patients ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("hud_patients")}
                >
                  <RiUser2Fill size={18} />
                  <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                    Patients
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/clinic/doctor-view"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.doctor_view ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("doctor_view")}
                >
                  <RiUser2Fill size={18} />
                  <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                    Doctor's View
                  </p>
                </NavLink>
              </li>}
              {getUserRole() !== "operator" ? <li>
                <NavLink
                  to="/dashboard"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.dashboard ? "text-white bg-primary rounded-md" : ""
                    }`}
                  onClick={() => handleIsActive("dashboard")}
                >
                  <AiOutlineAppstore size={18} />
                  <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                    Dashboard
                  </p>
                </NavLink>
              </li> : <></>}
              {getUserRole() === "admin" ? <li>
                <NavLink
                  to="/tpt-machines"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.tpt_machines ? "text-white bg-primary rounded-md" : ""
                    }`}
                  onClick={() => handleIsActive("tpt_machines")}
                >
                  <CiSettings size={18} />
                  <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                    TPT Machines
                  </p>
                </NavLink>
              </li> : <></>}
              {<li>
                <NavLink
                  to="/package-invoice"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.package_invoice ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("invoice")}
                >
                  <FiPackage size={18} />
                  <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                    Package Invoice
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/consultation-invoice"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.consultation ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("consultation")}
                >
                  <MdRealEstateAgent size={18} />
                  <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                    Consultation Invoice
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/invoice-medicine"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.medicine_invoice ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("medicine_invoice")}
                >
                  <GiMedicines size={18} />
                  <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                    Medicine Invoice
                  </p>
                </NavLink>
              </li>}
              {/* {<li>
                <NavLink
                  to="/patients"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.patients ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("patients")}
                >
                  <RiUser2Fill size={18} />
                  <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                    Patients
                  </p>
                </NavLink>
              </li>} */}
              {<li>
                <NavLink
                  to={getUserRole() === "operator" ? "/center-medicine" : "/medicine"}
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.medicine ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("medicine")}
                >
                  <GiMedicinePills size={18} />
                  <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                    {getUserRole() === "operator" ? "Center Medicines" : "Medicines"}
                  </p>
                </NavLink>
              </li>}
              {getUserRole() !== "operator" ? <li>
                <NavLink
                  to="/issued-medicines"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.issued_medicines ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("issued-medicines")}
                >
                  <MdDewPoint size={18} />
                  <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                    Issued Medicines
                  </p>
                </NavLink>
              </li> : <></>}
            </ul>
          </div>

        </div>
        <p className="text-[0.8rem] mb-4">
          <Link to={getUserRole() === "developer" ? "/developer" : null}>
            © Developed By: Rashail Tech. Labs
          </Link>
        </p>
      </div>
      <ShowModal contentLabel={"Open Lock OTP Modal"} isOpen={modalIsOpen} modalWidth="30%" onRequestClose={closeModal} componentToPass={<VerifyOtpPop item={openingItem} onOperation={() => handleSwitchToggle(openingItem, true)} />} />
    </motion.div>
  );
};

export default ClinicSidebar;
